import _objectDestructuringEmpty from "/app/node_modules/babel-runtime/helpers/objectDestructuringEmpty";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import { RoleEnum } from "@affiliation/enums";
import { responseToState } from "~/mappers";
import { encryptText, decryptText } from "~/plugins/crypto";
import { AuthenticationApi, SellersApi, BossApi, ChannelApi, TeamApi, SupervisorApi } from "../api";

export var state = function state() {
  return {
    roleId: null,
    userId: null,
    firstName: null, // 'Andrés',
    lastName: null, // 'Alamadrid Sanchez',
    isSuperUser: false,
    idTeam: null,
    username: null,
    token: "",
    email: "",
    documentNumber: "",
    documentType: "",
    channelCode: null,
    channelName: null,
    subChannelCode: null,
    subChannelName: null,
    groupChannelCode: null,
    groupChannelName: null,
    userIdAD: null
  };
};

export var getters = {
  fullName: function fullName(state) {
    return (state.firstName + " " + state.lastName).trim();
  },
  isAdmin: function isAdmin(state) {
    return state.roleId === RoleEnum.SUPER_ADMIN;
  },
  isBoss: function isBoss(state) {
    return state.roleId === RoleEnum.BOSS;
  },
  isSeller: function isSeller(state) {
    return state.roleId === RoleEnum.SELLER;
  },
  isSupervisor: function isSupervisor(state) {
    return state.roleId === RoleEnum.SUPERVISOR;
  },
  isAdminCollaborator: function isAdminCollaborator(state) {
    return state.roleId === 5;
  }, // id rol admin colaboradores
  isTariffManager: function isTariffManager(state) {
    return state.roleId === 6;
  }
};

export var actions = {
  authLogin: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, data) {
      var state = _ref.state,
          commit = _ref.commit,
          dispatch = _ref.dispatch;
      var username, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              username = data.user;
              //console.log("decrypt pass ", decryptText(data.password));

              _context.next = 3;
              return new AuthenticationApi(this.$axios).authLogin({
                username: username,
                password: encryptText(data.password),
                recaptchaToken: data.recaptchaToken
              });

            case 3:
              response = _context.sent;

              commit("setUserData", response);
              _context.next = 7;
              return dispatch("master-data/initialLoad", null, { root: true });

            case 7:
              this.$setAuthCookie(response);
              return _context.abrupt("return", response);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function authLogin(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return authLogin;
  }(),
  authLoginAd: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, data) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var email, userId, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              email = data.email, userId = data.userId;
              _context2.next = 3;
              return new AuthenticationApi(this.$axios).authLoginAd({
                email: email,
                userId: userId
              });

            case 3:
              response = _context2.sent;

              response.userIdAD = userId;
              commit("setUserData", response);
              _context2.next = 8;
              return dispatch("master-data/initialLoad", null, { root: true });

            case 8:
              this.$setAuthCookie(response);
              return _context2.abrupt("return", response);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function authLoginAd(_x3, _x4) {
      return _ref4.apply(this, arguments);
    }

    return authLoginAd;
  }(),
  getAuthUrl: function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, _ref6) {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _objectDestructuringEmpty(_ref6);

              _objectDestructuringEmpty(_ref5);

              _context3.next = 4;
              return new AuthenticationApi(this.$axios).getAuthUrl({});

            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getAuthUrl(_x5, _x6) {
      return _ref7.apply(this, arguments);
    }

    return getAuthUrl;
  }(),
  getUserAD: function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8, _ref9) {
      var code = _ref9.code;
      var res;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _objectDestructuringEmpty(_ref8);

              _context4.next = 3;
              return new AuthenticationApi(this.$axios).getUserAD({ code: code });

            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", res);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getUserAD(_x7, _x8) {
      return _ref10.apply(this, arguments);
    }

    return getUserAD;
  }(),
  forgotPassword: function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref11, data) {
      var state = _ref11.state;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return new AuthenticationApi(this.$axios).forgotPassword({
                email: data.email
              });

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function forgotPassword(_x9, _x10) {
      return _ref12.apply(this, arguments);
    }

    return forgotPassword;
  }(),
  loginOut: function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref13) {
      var state = _ref13.state,
          dispatch = _ref13.dispatch;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return new AuthenticationApi(this.$axios).loginOut({
                idUser: Number(state.userId) || 0,
                token: String(state.token) || "",
                user: state.username,
                idRole: state.roleId,
                userIdAD: state.userIdAD || ""
              });

            case 2:
              _context6.next = 4;
              return dispatch("cleanUserData");

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function loginOut(_x11) {
      return _ref14.apply(this, arguments);
    }

    return loginOut;
  }(),
  cleanUserData: function cleanUserData(_ref15) {
    var commit = _ref15.commit;

    this.$removeAuthCookie();
    commit("setUserData", {});
  },
  updatePassword: function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref16, data) {
      var state = _ref16.state;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new AuthenticationApi(this.$axios).updatePassword({
                email: data.email,
                beforePassword: encryptText(data.beforePassword),
                afterPassword: encryptText(data.afterPassword)
              }));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function updatePassword(_x12, _x13) {
      return _ref17.apply(this, arguments);
    }

    return updatePassword;
  }(),
  updatePasswordByRol: function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref18, data) {
      var dispatch = _ref18.dispatch,
          rootState = _ref18.rootState;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.t0 = rootState.user.roleId;
              _context8.next = _context8.t0 === 1 ? 3 : _context8.t0 === 2 ? 3 : _context8.t0 === 3 ? 5 : 7;
              break;

            case 3:
              dispatch("updatePasswordBossAndAdmin", data);
              return _context8.abrupt("break", 9);

            case 5:
              dispatch("updatePasswordSupervisor", data);
              return _context8.abrupt("break", 9);

            case 7:
              _context8.next = 9;
              return dispatch("updatePasswordSeller", data);

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function updatePasswordByRol(_x14, _x15) {
      return _ref19.apply(this, arguments);
    }

    return updatePasswordByRol;
  }(),
  updatePasswordSeller: function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref20, data) {
      var state = _ref20.state;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", new SellersApi(this.$axios).updatePasswordSeller({
                idSeller: Number(state.userId) || 0,
                newPassword: encryptText(data.newPassword) || ""
              }));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function updatePasswordSeller(_x16, _x17) {
      return _ref21.apply(this, arguments);
    }

    return updatePasswordSeller;
  }(),
  updatePasswordSupervisor: function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref22, data) {
      var state = _ref22.state;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", new SupervisorApi(this.$axios).updatePasswordSupervisor({
                idSupervisor: Number(state.userId) || 0,
                newPassword: encryptText(data.newPassword) || ""
              }));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function updatePasswordSupervisor(_x18, _x19) {
      return _ref23.apply(this, arguments);
    }

    return updatePasswordSupervisor;
  }(),
  updatePasswordBossAndAdmin: function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref24, data) {
      var state = _ref24.state;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", new BossApi(this.$axios).updatePasswordBossAndAdmin({
                idBoss: Number(state.userId) || 0,
                newPassowrd: encryptText(data.newPassword) || ""
              }));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function updatePasswordBossAndAdmin(_x20, _x21) {
      return _ref25.apply(this, arguments);
    }

    return updatePasswordBossAndAdmin;
  }(),
  showListByRol: function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref26) {
      var dispatch = _ref26.dispatch,
          state = _ref26.state;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.t0 = state.roleId;
              _context12.next = _context12.t0 === 1 ? 3 : _context12.t0 === 2 ? 6 : _context12.t0 === 3 ? 9 : _context12.t0 === 5 ? 12 : 15;
              break;

            case 3:
              _context12.next = 5;
              return dispatch("boss/list", null, { root: true });

            case 5:
              return _context12.abrupt("break", 15);

            case 6:
              _context12.next = 8;
              return dispatch("channel/list", null, { root: true });

            case 8:
              return _context12.abrupt("break", 15);

            case 9:
              _context12.next = 11;
              return dispatch("team/loadDateTeam", null, { root: true });

            case 11:
              return _context12.abrupt("break", 15);

            case 12:
              _context12.next = 14;
              return dispatch("boss/list", null, { root: true });

            case 14:
              return _context12.abrupt("break", 15);

            case 15:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function showListByRol(_x22) {
      return _ref27.apply(this, arguments);
    }

    return showListByRol;
  }()
};

export var mutations = {
  setUserData: function setUserData(state, data) {
    state.firstName = data.firstName;
    state.lastName = data.lastName;
    state.isSuperUser = data.isSuperUser || false;
    state.userId = data.idUser;
    state.roleId = data.idRole;
    state.idTeam = data.idTeam;
    state.token = data.token;
    state.email = data.email;
    state.documentNumber = data.documentNumber;
    state.documentType = data.documentType;
    state.username = data.username;
    state.channelCode = data.channelCode;
    state.channelName = data.channelName;
    state.subChannelCode = data.subChannelCode;
    state.subChannelName = data.subChannelName;
    state.groupChannelCode = data.groupChannelCode;
    state.groupChannelName = data.groupChannelName;
    state.userIdAD = data.userIdAD;
  },
  setToken: function setToken(state, token) {
    state.token = token;
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/store/user.js
// module id = ./src/store/user.js
// module chunks = 34